import { useMemo } from "react";
import { useCsAttributes } from "@plansoft-configuration-renderer/framework";
import { useVisibleLayout } from "@plansoft-configuration-renderer/layout";
import { buildNavigationFromLayout } from "./buildNavigationFromLayout";
import { flagGroupComplete } from "./flagGroupComplete";
/**
 * Builds navigation from layout and configuration object
 * @param options
 * @returns
 */
export function useBuildNavigationFromLayout(options) {
    const { showAllAttributes, showGroups } = options;
    // access visible layout from context
    const visibleLayout = useVisibleLayout();
    const attributes = useCsAttributes();
    return useMemo(() => {
        const items = buildNavigationFromLayout(visibleLayout, {
            showAllAttributes,
            showGroups,
        });
        items.forEach((item) => flagGroupComplete(item, attributes));
        return items;
    }, [attributes, visibleLayout, showAllAttributes, showGroups]);
}
//# sourceMappingURL=useBuildNavigationFromLayout.js.map